import unsupportedProp from '@mui/utils/unsupportedProp';

export default unsupportedProp;
